import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Button, Typography, Card, message } from "antd";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const OTPValidationSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^[0-9]{6}$/, "OTP must be a 6-digit number")
    .required("OTP is required"),
});

const OTPVerification = () => {
  const navigate = useNavigate();
  const [resendDisabled, setResendDisabled] = useState(false);

  const handleResend = () => {
    setResendDisabled(true);
    setTimeout(() => setResendDisabled(false), 60000); // Enable after 60 sec
    axios
      .post(`${process.env.REACT_APP_BACKEND_URI}/auth/forgot-password`, {
        email_or_phone: localStorage.getItem("verification_email"),
        type: "email",
      })
      .then((response) => {
        navigate("/verify-otp");
        message.success("OTP Resent Successfully , Please chek Your Email")
      })
      .catch((error) => {
        console.log(error);
        message.error(error.response.data[0].otp);
      });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#f5f5f5",
      }}
    >
      <Card style={{ width: 400, textAlign: "center", padding: 20 }}>
        <Title level={3}>OTP Verification</Title>
        <Text>
          Please enter the OTP sent to your email{" "}
          {localStorage.getItem("verification_email")}
        </Text>
        <Formik
          initialValues={{ otp: "" }}
          validationSchema={OTPValidationSchema}
          onSubmit={(values) => {
            values.type = "email";
            values.email_or_phone = localStorage.getItem("verification_email");
            values.reset_token = values.otp;
            axios
              .post(
                `${process.env.REACT_APP_BACKEND_URI}/auth/verify-token`,
                values
              )
              .then((response) => {
                localStorage.setItem("verification_otp", values.otp);
                navigate("/reset-password");
              })
              .catch((error) => {
                console.warn(error)
                message.error("Invalid OTP , please try again !");
              });
          }}
        >
          {({ errors, touched, handleChange }) => (
            <Form style={{ marginTop: 20 }}>
              <Field
                name="otp"
                as={Input}
                maxLength={6}
                onChange={handleChange}
                placeholder="Enter OTP"
                status={errors.otp && touched.otp ? "error" : ""}
              />
              {errors.otp && touched.otp && (
                <Text type="danger">{errors.otp}</Text>
              )}

              <Button
                type="primary"
                htmlType="submit"
                block
                style={{ marginTop: 20 }}
              >
                Verify OTP
              </Button>
            </Form>
          )}
        </Formik>
        <Button
          type="link"
          onClick={handleResend}
          disabled={resendDisabled}
          style={{ marginTop: 10 }}
        >
          Resend OTP
        </Button>
      </Card>
    </div>
  );
};

export default OTPVerification;
